export default __webpack_public_path__ + "static/profile-a671467797a5e591269a7c7916508b5f.webp";